/* Full route config: public + admin. The single-bundle build exposes admin routes only when the current URL is under /admin/* (isAdminRoute below). */
/* eslint-disable react-refresh/only-export-components -- route config module, not a component file */
import { IRouteProps } from '@/app/app-router'

import { adminRoutes } from './config-admin'
import { publicRoutes } from './config-public'

export { adminRoutes } from './config-admin'

const isAdminRoute = (): boolean =>
  typeof window !== 'undefined' &&
  (window.location.pathname === '/admin' ||
    window.location.pathname.startsWith('/admin/'))

export const RouterConfigurationList = (): IRouteProps[] =>
  isAdminRoute() ? [...publicRoutes, ...adminRoutes] : publicRoutes

export const RouterConfiguration = (): IRouteProps[] =>
  RouterConfigurationList()

export { isAdminRoute }
export { publicRoutes } from './config-public'
